import { SimpleMutationOptions, useBaseMutation } from "../baseMutation";
import { CreateDocumentFilesRequest, CreateDocumentFilesResponse } from "@maven-rest/docs/FolderFile.dto";
import { FolderFileUrl } from "@maven-rest/docs/FolderFile.url";

export function useCreateDocumentFilesMutation(options?: SimpleMutationOptions<CreateDocumentFilesResponse, CreateDocumentFilesRequest>) {
  return useBaseMutation({
    fnOption: { url: FolderFileUrl.createDocumentFiles },
    ...options,
  });
}
